import { BaseType } from '../base/base-type';

export class RemittanceFrequencyType extends BaseType {}
